/* eslint-disable import/no-unresolved */
import 'swiper/css';
import 'swiper/css/free-mode';

import React from 'react';
import cx from 'clsx';
import { Lazy } from 'swiper';
import { Swiper, SwiperSlide } from 'swiper/react';

import { SectionDivider } from '~/components/SectionDividor';
import { OFFERS_ROUTER } from '~/constants/router';
import { PRODUCT_TYPE_E_COUPON } from '~/domains/e-coupon/constants';
import ECouponProductCard from '~/domains/products/components/ECouponProductCard';
import { useRecentlyViewedProducts } from '~/domains/products/queries';
import { useLinkComponent } from '~/hooks/mobileApp';

import RecentlyViewedProductCard from './RecentlyViewedProductCard';
import RecentlyViewedProductsSkeleton from './RecentlyViewedProductsSkeleton';

import { MoreIcon } from '~/assets/icons';

const eventOption = {
  detailedPlaceMent: '최근본상품',
};

interface Props {
  titleClassName?: string;
}

const RecentlyViewedProductsContent = ({ titleClassName }: Props) => {
  const products = useRecentlyViewedProducts();
  const LinkComponent = useLinkComponent();

  if (!products || products.length < 1) {
    return null;
  }

  return (
    <>
      <div className="my-24">
        <div className="mb-16 flex items-center justify-between px-20">
          <h2 className={cx('typo-heading100 text-gray-1400', titleClassName)}>
            최근 본 상품
          </h2>
          <LinkComponent
            href={OFFERS_ROUTER.recentlyViewed}
            className="ml-8 shrink-0"
          >
            <span className="flex items-center text-blue-800 typo-paragraph100-regular">
              전체보기
              <MoreIcon />
            </span>
          </LinkComponent>
        </div>

        <div>
          <Swiper modules={[Lazy]} slidesPerView="auto" lazy>
            {products.map((product) => {
              return (
                <SwiperSlide
                  key={product.offerId}
                  className="ml-12 !w-[140px] first-of-type:ml-20 last-of-type:mr-20"
                >
                  {product.productType === PRODUCT_TYPE_E_COUPON ? (
                    <ECouponProductCard
                      {...product}
                      reverseCouponDiscountedPrice
                      eventOption={eventOption}
                    />
                  ) : (
                    <RecentlyViewedProductCard
                      {...product}
                      plusMembershipFullBadge
                      reverseCouponDiscountedPrice
                      eventOption={eventOption}
                    />
                  )}
                </SwiperSlide>
              );
            })}
          </Swiper>
        </div>
      </div>
      <SectionDivider />
    </>
  );
};

const RecentlyViewedProducts = (props: Props) => {
  return (
    <React.Suspense fallback={<RecentlyViewedProductsSkeleton />}>
      <RecentlyViewedProductsContent {...props} />
    </React.Suspense>
  );
};

export default RecentlyViewedProducts;
